/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { CmsVideoComponent, I18nModule, Product } from '@spartacus/core';
import { ProductImageZoomModule } from '@spartacus/product/image-zoom';
import { ProductImageZoomProductImagesComponent } from '@spartacus/product/image-zoom/components';
import { CarouselModule, MediaModule, MediaService } from '@spartacus/storefront';
import { CustomVideoComponent } from '../../../video/video.component';
import { map, Observable, of, tap } from 'rxjs';
import { CustomProductImageZoomTriggerComponent } from '../product-image-zoom-trigger/product-image-zoom-trigger.component';

@Component({
  selector: 'cx-product-images',
  templateUrl: './product-image-zoom-product-images.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    CommonModule,
    CarouselModule,
    MediaModule,
    ProductImageZoomModule,
    I18nModule,
    CustomVideoComponent,
    CustomProductImageZoomTriggerComponent,
  ],
})
export class CustomProductImageZoomProductImagesComponent extends ProductImageZoomProductImagesComponent {
  mediaService = inject(MediaService);

  override openImage(item: any): void {
    this.mainMediaContainer.next(item);
  }

  isVideo(item: any) {
    return this.mediaService.getMedia(item)?.src.includes('.mp4');
  }

  convertToVideoSource(item: any): CmsVideoComponent {
    const sourceSet = this.mediaService.getMedia(item);
    return {
      video: { url: sourceSet?.src, altText: sourceSet?.alt },
      thumbnail: { url: item.thumbnail },
    };
  }
}
